const SUGGESTIONS = ["My TV has no sound", "Wi-Fi keeps dropping", "Camera app won't connect", "How much is a session?"];

export function ChatMessages({ msgs, onSuggestion, endRef }) {
  return (
    <div className="flex-1 overflow-y-auto dg-scroll p-4 space-y-3 text-sm">
      {msgs.length === 0 && (
        <div>
          <div className="rounded-xl bg-slate-800/70 p-3 text-slate-200">Hi! I'm the Dr.Gadget assistant. Describe your tech problem and I'll suggest some quick fixes — or ask about sessions and pricing.</div>
          <div className="flex flex-wrap gap-2 mt-3">
            {SUGGESTIONS.map((s) => <button key={s} onClick={() => onSuggestion(s)} className="dg-chip hover:border-cyan-400 transition-colors" data-testid="chat-suggestion">{s}</button>)}
          </div>
        </div>
      )}
      {msgs.map((m) => (
        <div key={m.id} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
          <div className={`max-w-[85%] rounded-xl px-3 py-2 whitespace-pre-wrap leading-relaxed ${m.role === "user" ? "bg-cyan-500 text-slate-900" : "bg-slate-800/70 text-slate-200"}`} data-testid={`chat-msg-${m.role}`}>
            {m.content || <span className="inline-block w-2 h-4 bg-cyan-400 animate-pulse rounded-sm" />}
          </div>
        </div>
      ))}
      <div ref={endRef} />
    </div>
  );
}
